<script setup>
import FAQCell from '@/pages/faq/components/FAQCell.vue';
import FAQGroup from '@/components/common/FAQGroup.vue';

import { CLAIM_FAQ_VOXEL_ITEMS } from '@/constants/faq';

const items = [...CLAIM_FAQ_VOXEL_ITEMS];

const props = defineProps({});
</script>

<template>
  <FAQGroup title="Voxels" bgVariant="blue">
    <template #graphic>
      <img src="@/assets/vox_1.png" :class="s.graphic" />
    </template>
    <FAQCell
      v-for="({ title, subcontent }, index) in items"
      :key="index"
      :title="title"
      :subcontent="subcontent"
    />
  </FAQGroup>
</template>

<style module="s" lang="scss">
.graphic {
  position: relative;
  left: -14px;
}
</style>
